import { Component, Input, OnInit } from '@angular/core';
import { trackByRoute } from '../../utils/track-by';
import { NavigationService } from '../../services/navigation.service';
import icRadioButtonChecked from '@iconify/icons-ic/twotone-radio-button-checked';
import icRadioButtonUnchecked from '@iconify/icons-ic/twotone-radio-button-unchecked';
import { LayoutService } from '../../services/layout.service';
import { ConfigService } from '../../services/config.service';
import { debounceTime, distinctUntilChanged, map, skip, switchMap } from 'rxjs/operators';
import { TranslateService } from '@ngx-translate/core';
import { AuthenticationService } from 'src/@vex/services/authenticationService/authentication.service';
import { MatDialog } from '@angular/material/dialog';
import { SubscriptionComponent } from 'src/app/pages/apps/settings/company-setting/memberships/subscription/subscription.component';
import { MembershipService } from 'src/app/pages/apps/settings/company-setting/memberships/membership.service';
import { of } from 'rxjs';
import { PreferenceKeys } from 'src/app/interfaces/preference-keys.enum';

@Component({
  selector: 'vex-sidenav',
  templateUrl: './sidenav.component.html',
  styleUrls: ['./sidenav.component.scss']
})
export class SidenavComponent implements OnInit {

  @Input() collapsed: boolean;
  collapsedOpen$ = this.layoutService.sidenavCollapsedOpen$;
  title$ = this.configService.config$.pipe(map(config => config.sidenav.title));
  imageUrl$ = this.configService.config$.pipe(map(config => config.sidenav.imageUrl));
  showCollapsePin$ = this.configService.config$.pipe(map(config => config.sidenav.showCollapsePin));

  items = this.navigationService.items;
  trackByRoute = trackByRoute;
  icRadioButtonChecked = icRadioButtonChecked;
  icRadioButtonUnchecked = icRadioButtonUnchecked;
  
  loginUserData;
  profileImage;
  userRole;
  membershipName = "Free";

  membershipUpgradeVisible = false;

  constructor(
    private navigationService: NavigationService,
    private layoutService: LayoutService,
    public translate: TranslateService,
    private _authenticationService: AuthenticationService,
    private membershipService: MembershipService,
    private configService: ConfigService, 
    private dialog: MatDialog) {
    _authenticationService.userRole.subscribe(role => {
      this.userRole = role;
    });
  }

  ngOnInit() {
    this.loginUserData = JSON.parse(localStorage.getItem('UserInfo'));
    
    const membership = localStorage.getItem('membership');
    this.membershipUpgradeVisible = this.loginUserData.role === 5 && membership == '0';

    if (membership != '0' && membership != '1' && membership != '') {
      const membershipPackages = JSON.parse(localStorage.getItem(PreferenceKeys.MembershipPackages));

      const subscribed = membershipPackages.find(
        p => p.id == membership
      );
      if (subscribed !== undefined)
        this.membershipName = subscribed.name;
    }

    const membershipUpdated = this.membershipService.membership.pipe(
      skip(1), 
      debounceTime(500), 
      distinctUntilChanged(), 
      switchMap( current => {
        return of(current);
      })
    );

    membershipUpdated.subscribe(current => {
      this.membershipUpgradeVisible = this.loginUserData.role === 5 && current == '0';
    });

    this.profileImage = this.loginUserData.Avatar.replace("$#$", "");
  }

  onMouseEnter() {
    this.layoutService.collapseOpenSidenav();
  }

  onMouseLeave() {
    this.layoutService.collapseCloseSidenav();
  }

  toggleCollapse() {
    this.collapsed ? this.layoutService.expandSidenav() : this.layoutService.collapseSidenav();
  }

  checkURL(url) {
    return(url.match(/\.(jpeg|jpg|gif|png)$/) != null);
  }

  upgradeMembership() {
    this.dialog.open(SubscriptionComponent, {
      width: '100%', 
      autoFocus: false,
      disableClose: true
    })
    .afterClosed()
    .subscribe(updated => {

    });
  }
}
